import { render } from "./TeachData.vue?vue&type=template&id=40f7955e&scoped=true"
import script from "./TeachData.vue?vue&type=script&lang=js"
export * from "./TeachData.vue?vue&type=script&lang=js"

import "./TeachData.vue?vue&type=style&index=0&id=40f7955e&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户海南大学-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f7955e"]])

export default __exports__